"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var infinitize = function (num) {
    return num === -1 || num === 'unlimited' ? Infinity : Number(num);
};
exports.default = infinitize;
